import { Notifications } from '@mantine/notifications';
import type { ReactNode } from 'react';

interface NotificationsProviderProps {
  children: ReactNode;
}

export const NotificationsProvider = ({
  children,
}: NotificationsProviderProps) => {
  return (
    <>
      <Notifications
        data-test-id="notifications-container"
        position="top-center"
        zIndex={1000}
      />
      {children}
    </>
  );
};
